import { Address } from '../../types/address';

export const AddressInitialValues: Address = {
  municipalityId: null,
  municipalityName: '',
  placeId: null,
  placeName: '',
  streetId: null,
  streetName: '',
  housenumber: '',
  entrance: '',
  apartment: '',
  rawName: '',
  location: null,

  stateId: null,
  countryCode: null,
  countryId: null,
  cityId: null,
  cityName: null,
  postcode: null,
  zoneId: null,
};
